import React from 'react'
import { Card } from '../shared/card/card'
import { ForgetAccountOffer } from '../shared/recent-accounts/forget-account'

// Where the identity provider returns the browser after the desktop, VR or
// mobile app signs out with "end the identity provider session" on. The app
// opened the provider's sign-out in the system browser, so this is a tab the
// user never meant to use -- same shape as OpenComplete's "close this window
// and return to the app" after sign-in.
//
// Recent accounts (owner 2026-10-25): when this browser remembers accounts
// for the sign-in page, the card offers to forget them here
// (ForgetAccountOffer: the page can't tell which account signed out).
export const OpenSignedOut = () =>
  <Card>
    <div className="pt-3">
      <p>You're signed out of EducationXR and your identity provider.</p>
      <p>You can close this window and return to the app.</p>
      <ForgetAccountOffer />
    </div>
  </Card>
